// extracted by mini-css-extract-plugin
export default {"root":"DataTable_root__SY4va","table":"DataTable_table__VimPf"};